
import { call, takeLatest } from 'redux-saga/effects';
import { ISagaFunc } from 'services/actionConfigs';
import storage from 'utils/sessionStorage';
import actions from './actions';
import { IOwnerLoginResData } from './types/owner';
import { IResponseDataBody } from 'services/response';
import apis from './apis';
import { SHOP_DEVICE_TYPE } from 'services/shop/constants';
import shopApis from 'services/shop/apis';
const ownerLoginSuccess: ISagaFunc<IOwnerLoginResData> = function* ({ payload }) {
  const { accessToken, refreshToken } = payload;
  yield storage.token.set(accessToken);
  yield storage.refresh_token.set(refreshToken);
};

const ownerLogout = function* () {
  const shopId: string = yield storage.shop_id.get();
  if (!shopId) return;
  try {
    const res: IResponseDataBody<boolean> = yield call(apis.ownerLogout);
    if (res.data.data) {
      yield storage.shop_id.set('');
      yield storage.station_number.set('');
    }
  } catch (error) {

  }
};

const addDeviceIdAsync = async (shopId: string, deviceId: string, method: SHOP_DEVICE_TYPE) => {
  const res: IResponseDataBody<boolean> = await shopApis.addDevice(shopId, deviceId, method);
  return res.data.data;
};

const addDeviceId: ISagaFunc<{ shopId: string, deviceId: string }> = function* ({ payload }) {
  const { shopId, deviceId } = payload;
  try {
    yield call(addDeviceIdAsync, shopId, deviceId, SHOP_DEVICE_TYPE.POS);
  } catch (error) { }
};
export default function* authServiceSagas() {
  yield takeLatest(actions.ownerLogin.success, ownerLoginSuccess);
  yield takeLatest(actions.ownerLogout, ownerLogout);
  yield takeLatest(actions.addDeviceId, addDeviceId);
}
